<mat-selection-list [multiple]="false">
    <mat-list-option *ngFor="let domain of domains" [value]="domain" (click)="select(domain)">
      {{domain.name}}
    </mat-list-option>
</mat-selection-list>